export default "__VITE_ASSET__2fa67af7__"